import React, {useEffect, useState} from 'react';

import {Row} from '../../../components/layout';
import './styles.scss';
import {connect} from 'react-redux';
import {compose} from 'redux';

interface BubbleMedicoOnlineProps {
  globalStyles: any;
  classNames: any;
  width?: any;
  height?: any;
}

function BubbleMedicoOnline({
  globalStyles,
  classNames,
  width,
  height,
}: BubbleMedicoOnlineProps) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  function getWindowWidth() {
    const {innerWidth: width} = window;
    setWindowWidth(width);
  }

  useEffect(() => {
    window.addEventListener('resize', getWindowWidth);
    return () => window.removeEventListener('resize', getWindowWidth);
  }, []);

  return (
    <Row className={classNames}>
      <svg
        width={width ? width : windowWidth <= 768 ? '180px' : '140px'}
        height={height ? height : windowWidth <= 768 ? '180px' : '140px'}
        viewBox="0 0 302 308"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>MUTUAL/PHOTOS/Bubbles/consultas-online</title>
        <defs>
          <linearGradient
            x1="0%"
            y1="20.3493793%"
            x2="103.325195%"
            y2="79.6506207%"
            id="linearGradient-1">
            <stop stopColor={globalStyles.primaryColor} offset="0%"></stop>
            <stop stopColor={globalStyles.primaryColor} offset="100%"></stop>
          </linearGradient>
        </defs>
        <g
          id="MUTUAL/PHOTOS/Bubbles/consultas-online"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd">
          <path
            d="M155.461079,302.133592 C231.328212,294.864148 287.5,266.963576 287.5,193.767635 C287.5,120.571693 218.408842,65.2534703 135.419109,105.612294 C91.5256937,126.958147 28.3058942,110.048761 14.9951304,190.434613 C1.68436673,270.820465 79.593946,309.403035 155.461079,302.133592 Z"
            id="Bubble"
            fill="url(#linearGradient-1)"
            fillRule="nonzero"
            transform="translate(150.500000, 197.500000) scale(-1, 1) translate(-150.500000, -197.500000) "></path>
          <path
            d="M142.461079,307.133592 C218.328212,299.864148 274.5,271.963576 274.5,198.767635 C274.5,125.571693 205.408842,70.2534703 122.419109,110.612294 C78.5256937,131.958147 15.3058942,115.048761 1.99513044,195.434613 C-11.3156333,275.820465 66.593946,314.403035 142.461079,307.133592 Z"
            id="Bubble"
            fill={globalStyles.primaryColor}
            opacity="0.456798735"
            style={{mixBlendMode: 'multiply'}}
            transform="translate(137.500000, 202.500000) scale(-1, -1) translate(-137.500000, -202.500000) "></path>
        </g>
      </svg>
    </Row>
  );
}

const mapStateToProps = ({globalStyles}: any) => ({
  globalStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(BubbleMedicoOnline));
